import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import {
	getCounselFeeHover,
	getPremiumPillHover,
	TitleInsurancePillData,
} from '@core/util/title-insurance';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { MatterManualTitleInsurance } from '@models/title-insurance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { combineLatest, Observable } from 'rxjs';
import { TestHooks } from './commercial-order-summary.hooks';

@UntilDestroy()
@Component({
	selector: 'app-commercial-order-summary',
	templateUrl: './commercial-order-summary.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CommercialOrderSummaryComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	public displayPill = 'none';
	public premiumPillData: TitleInsurancePillData;
	public counselPillData: TitleInsurancePillData;

	@Select(SelectedMatter.getTitleInsurance)
	titleInsurance$: Observable<MatterManualTitleInsurance>;
	@Select(SelectedMatter.getTitleInsuranceDirectionOfAmount)
	titleInsuranceDOA$: Observable<DirectionOfFeeType>;
	@Select(SelectedMatter.titleInsuranceCounselCredit)
	counselCredit$: Observable<number>;
	@Select(SelectedMatter.titleInsuranceAmountDueByClient)
	amountDueByClient$: Observable<number>;
	@Select(SelectedMatter.titleInsurancePremium) premium$: Observable<number>;
	@Select(SelectedMatter.titleInsuranceOrderedOn)
	orderedOn$: Observable<string>;
	@Select(SelectedMatter.titleInsuranceReferenceNumber)
	orderNumber$: Observable<string>;
	@Select(SelectedMatter.titleInsuranceEffectiveDate)
	effectiveDate$: Observable<string>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Output() goBack = new EventEmitter<Event>();

	ngOnInit(): void {
		combineLatest([this.titleInsurance$, this.titleInsuranceDOA$])
			.pipe(untilDestroyed(this))
			.subscribe(([titleInsurance, titleInsuranceDOA]) => {
				this.premiumPillData = getPremiumPillHover(titleInsuranceDOA);
				this.counselPillData = getCounselFeeHover(
					titleInsurance,
					titleInsuranceDOA,
				);
			});
	}

	togglePill(_displayPill: string): void {
		this.displayPill =
			this.displayPill === _displayPill && this.displayPill !== 'none'
				? 'none'
				: _displayPill;
	}

	editPolicyDetails(): void {
		this.goBack.emit();
	}
}
